import styled from 'styled-components';
import { IconButton as ButtonBase, IconButtonProps } from '@mui/material';

type Props = IconButtonProps & {
  color?: 'error';
  width?: string;
  height?: string;
  variant?: 'outlined';
};

const IconButton = styled(ButtonBase)<Props>`
  border-radius: 8px;
  padding: 4px;
  ${({ width }) => width && `width: ${width}`};
  height: ${({ height }) => height ?? 'fit-content'};
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  border: ${({ variant, theme }) =>
    variant === 'outlined'
      ? `1px solid ${theme.palette.common.gray18}`
      : 'none'};
`;

export default IconButton;
